import * as React from "react";

var Header = function Header(props) {
  var polizaRenewal = props.polizaRenewal;
  var poliza = polizaRenewal.poliza;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    style: {
      display: "inline-block"
    },
    id: "exampleModalLabel"
  }, "Propuesta: ", poliza === null || poliza === void 0 ? void 0 : poliza.id, " ", poliza !== null && poliza !== void 0 && poliza.code ? "- N\xBA p\xF3liza: ".concat(poliza === null || poliza === void 0 ? void 0 : poliza.code) : ""), /*#__PURE__*/React.createElement("div", {
    style: {
      "float": "right"
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "close",
    "data-dismiss": "modal",
    "aria-label": "Close"
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7"))));
};

export default Header;